<template>
  <div class="escape-the-rut">
    <p class="text">Scroll to escape the fruit rut.</p>
    <scroll-down-arrow class="icon" />
  </div>
</template>

<script>
import Arrow from '../../assets/icons/scroll-down-arrow.svg?inline'

export default{
  name: 'escape-the-rut',
  components: {
    'scroll-down-arrow': Arrow
  }
}
</script>

<style scoped lang="scss">
/** escape-the-rut **/
@import '../../theme';

@keyframes pulse {
  from {
    transform: scale(1);
    opacity: 0.8;
  }
  to {
    transform: scale(1.5);
    opacity: 0;
  }
}

.escape-the-rut {
  position: absolute;
  bottom: -80px;
  right: -40px;

  display: flex;
  width: 175px;
  height: 175px;
  align-items: center;

  border-radius: 50%;
  background-color: zespri-brand-color(red);

  &:after {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;

    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;

    content: '';
    background-color: zespri-brand-color(red);
    animation: pulse 2s $e-out-hard infinite;
  }
}

.text, .icon {
  transform: translate(40px, -30px);
}

.text {
  padding-right: 0;
  width: 60px;
  box-sizing: border-box;
  margin: 0 5px 0 0;

  @include zespri-tiny-title;
  color: zespri-foreground-dark(text);
  text-align: right;
  text-transform: uppercase;
}

.icon {
  width: 15px;
  height: 40px;
  fill: zespri-brand-color(dark-green);
}

</style>
